import React from 'react';
import SetForm from "./../../../Common/SetForm";
import Form from "./../../../../lib/FieldForm";
import { PParamsData } from "./../../../../../platform.es.config";
import { formatAmount, formatNumber } from "./../../../../lib/utils";
import { getFEWalletParams } from "./../../../../../platform.pay.config";
import { CommonPostPay, getExchange, getCTCListAndExchange, InsertNewAccountHolderName } from "./../../../../lib/api/api.data";
import { mul } from "./../../../../lib/utils";
import { withdrawModalHandle } from "./../../../../lib/data/withdrawKyc.static"
import translate from "./../../../../lib/translate/TranslateJs";
import { connect } from 'react-redux';
import moment from 'moment';

class CCW extends SetForm {
    constructor(props) {
        super(props);
        this.state = {
            ...this.commonState,
            ctcType: "",
            exchangeRateInfo: {},
            USDTExchangeRate: "",
            exchangeRate: "",
            exchangeRateVal: "",
            ETRC20: [],
            disabled: false,
            tutoriaVisible: false,
            checkBoxValue: false,
            depositMoney: ""
        };

        this.typeCode = "CCW";
        this.memberBank = {}; // 记录选中的会员银行卡信息
        this.transactionId = ""; // 订单编号

        this.feWalletParams = getFEWalletParams();

    }
    componentDidMount() {
        this.didMount();
        this.showModal();
        this.feWalletParams.webPiwikUrl("withdrawal_crypto", "Withdrawal")
    }
    componentDidUpdate(prevProps, prevState) {
        this.didUpdate(prevProps, prevState);

        if (prevState.step !== this.state.step) {
            this.state.step !== 1 && this.setState({exchangeRateVal: ""}); // 清空已记录的汇率信息
        }

        if (prevState.ctcType !== this.state.ctcType && this.state.ctcType) {
            this.setState({
                exchangeRateInfo: {},
                USDTExchangeRate: "",
                exchangeRate: "",
                exchangeRateVal: "",
            }, ()=>{
                this.getCTCList(this.state.ctcType);
            })
        }

        if(prevState.tutoriaVisible !== this.state.tutoriaVisible && this.state.tutoriaVisible){
            if (this.feWalletParams.device == 'APP') {
                this.feWalletParams.appPiwikEvent({
                    category: 'Withdrawal',
                    action: `View Tutorial`,
                    name: `Withdrawal_Crypto_C_Tutorial`,
                    path: `withdrawal`,
                    title: `Withdrawal`
                })
            } else {
                this.feWalletParams.webPiwikEvent("Withdrawal", "View Tutorial", "Withdrawal_CTC_C_Tutorial")
            }
        }

    }
    componentWillUnmount() {
        this.willUnmount();
    }
    showModal = async (v) => {
        try{
            const {isDeposited} = this.props.memberInfo;
            let GlobalStorage = this.props.GlobalStorage()
            let flag = await GlobalStorage.load(`ChargeNoticeWithdraw${this.props.memberInfo.userName}`)
            if (isDeposited && !flag) {
                if (this.feWalletParams.device == 'APP') {
                    this.feWalletParams.appPiwikEvent({
                        path: `withdrawal_crypto_popup`,
                        title: `WithdrawalCrypto Popup`
                    })
                } else {
                    this.feWalletParams.webPiwikUrl("withdrawal_crypto_popup", "Withdrawal")
                }
                
                let ChargeNoticeWithdraw = this.props.ChargeNoticeWithdraw
                this.feWalletParams.modalTip.confirm({
                    wrapClassName:"keepingFeeModal hideCancelBtnWithdraw",
                    type:"confirm",
                    maskClosable:false,
                    onlyOKBtn: true,
                    buttonNum: 1,
                    okBtnTxt: translate("是的，我知道了")(),
                    okFunction: () => {
                        this.state.checkBoxValue && GlobalStorage.save(`ChargeNoticeWithdraw${this.props.memberInfo.userName}`)
                        this.feWalletParams.webPiwikUrl("withdrawal_crypto", "Withdrawal")
                    },
                    title: translate("温馨提示(Crypto)")(),
                    children: <ChargeNoticeWithdraw
                      getCheckBoxValue={value => {
                          this.setState({
                              checkBoxValue: value
                          })
                      }}
                    ></ChargeNoticeWithdraw>,
                })
            }
        }catch (e) {
            console.log('showModal error ', e)
        }
    }
    addAddUSDT = () => {
        // this.feWalletParams.goAddBankInfo("usdt");
        this.feWalletParams.goAddBankInfo('usdt', this.state.ctcType, (type) => {
            this.getCTCList(type)
        });

        if (this.feWalletParams?.device == 'APP') {
            this.feWalletParams?.appPiwikEvent({
                category: 'Withdrawal',
                action: `Add Bank Account`,
                name: `Withdrawal_Crypto_C_Add ${this.state.ctcType}`,
                path: `withdrawal`,
                title: `Withdrawal`
            })
        }
    }
    rateTip = () => {

        const { exchangeRateInfo, ctcType, depositMoney } = this.state;
        const { ExchangeExtra2Confirm } = this.props;
        const AmountResult = depositMoney;
        const UsdtDate = moment(exchangeRateInfo.balancesUpdatedAt).format("DD-MM-YYYY");
        const UsdtDepositd = formatNumber(exchangeRateInfo.depositedAmount);
        const UsdtWithdraw = formatNumber(exchangeRateInfo.withdrawAmount);
        const UsdtWithdrawBalance = formatNumber(exchangeRateInfo.withdrawableBalances);
        const TiersAmount1 = formatNumber(exchangeRateInfo.tiersAmount[1], 2, true);
        const TiersAmount2 = formatNumber(exchangeRateInfo.tiersAmount[2], 2, true);
        const TiersExchangeAmount1 = formatNumber(exchangeRateInfo.tiersExchangeAmount[1]);
        const TiersExchangeAmount2 = formatNumber(exchangeRateInfo.tiersExchangeAmount[2]);
        const ConvertedAmount = formatNumber(exchangeRateInfo.convertedAmount)

        if (this.feWalletParams?.device == 'APP') {
            this.feWalletParams?.appPiwikEvent({
                path: `withdrawal_crypto_convert_crypto`,
                title: `WithdrawalCrypto Convert Popup`
            })
        }

        this.feWalletParams.modalTip.confirm({
            wrapClassName: 'cryptoTier2Modal', 
            title: translate("加密货币转换")(),
            children: <ExchangeExtra2Confirm
                money={{
                    label: translate("您请求提取的金额：")(),
                    value: translate("<#0#> RMB")(AmountResult)
                }}
                usdtInfo={[{
                    label: translate("截至目前您存入的加密货币总额<#0#>")(UsdtDepositd),
                    value: translate("最后更新时间：<#0#>")(UsdtDate)
                }, {
                    label: translate("截至目前您提款的加密货币总额<#0#>")(UsdtWithdraw),
                    value: translate("最后更新时间：<#0#>")(UsdtDate)
                }, {
                    label: translate("截至目前您的加密货币余额<#0#>")(UsdtWithdrawBalance),
                    value: translate("最后更新时间：<#0#>")(UsdtDate)
                }]}
                rateInfo={[
                {
                    label: translate("您的加密货币余额将按照一级汇率进行转换(免费)：")(),
                    value: translate("<#0#> RMB = <#1#><#2#>")(TiersAmount1, TiersExchangeAmount1, this.state.ctcType)
                }, {
                    label: translate("剩余的请求金额将按第二级汇率换算(需支付费用)：")(),
                    value: translate("<#0#> RMB = <#1#><#2#>")(TiersAmount2, TiersExchangeAmount2, this.state.ctcType)
                }, {
                    label: translate(ctcType==="USDT-ERC20" ? "USDT-ERC20 您可以提取的等值加密货币：" : "USDT-TRC20 您可以提取的等值加密货币：")(),
                    value: translate("<#0#> <#1#>")(ConvertedAmount, this.state.ctcType)
                }]}
                tip={translate("注：汇率仅供参考，交易将按交易时的汇率计算。")()}
            />,
            okBtnTxt: translate("我已知晓")(),
            noBtnTxt: translate("在线客服")(),
            noFunction: () => {
                this.feWalletParams.openService();
            },
        });
    }
    moneyChangeCallback = (value) => {
        const multiplier = this.feWalletParams.languageType === "M3" ? 1000 : 1;

        const updateState = {
            depositMoney: value,
        };
        if (this.state.exchangeRate) {
            updateState.exchangeRateVal = formatAmount(mul(parseFloat(value * (multiplier)), this.state.exchangeRate), 3);
        }

        this.setState(updateState);

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            getExchange({
                money: value,
                type: this.state.ctcType
            }, (res) => {
                typeof res === "object" && this.setState({exchangeRateInfo: res});
            });
        }, 600);

    }
    getCTCList = (type) => {
        this.props.setLoading(true);

        getCTCListAndExchange(type, (eTRC20Data, exchangeRate) => {
            if (exchangeRate) {
                this.setState({
                    exchangeRate: exchangeRate.exchangeRate,
                    USDTExchangeRate: formatAmount(( 1 / exchangeRate.exchangeRate ), 3)
                });
            }

            if (Array.isArray(eTRC20Data) && eTRC20Data.length) {
                let list = eTRC20Data;

                if (eTRC20Data.length <= 2) {// 泰达币最多三个
                    let ctcname = `${translate("添加 <#0#> 钱包地址")(type)}`;
                    ctcname = this.feWalletParams?.device === "WEB" ? ctcname.replace("+","") : ctcname;
                    list.push({
                        type: "push",
                        name: ctcname,
                        walletAddress: -1
                    })
                }

                this.setState({ETRC20: eTRC20Data, disabled: false});

                const CTCAddressVal = eTRC20Data[0].walletAddress;
                this.formStaticData.setData("ctcAddress", CTCAddressVal); // 记录切换步骤需要保留的值
                this.setCurrFormData({ctcAddress: CTCAddressVal}); // 设置第一个结果为初始值
            } else {
                this.setState({ETRC20: [], disabled: true}, () => {
                    this.setSubmitButtonStatus();
                });
            }
        }, () => {
            this.props.setLoading(false);
        })
    }
    submitOnce = async (values) => {

        if (!this.props.withdrawalStatusCheck(this.typeCode)) return;
        this.setState({
            submitDisabled: true
        });
        setTimeout(()=>{
            this.setState({
                submitDisabled: false
            });
        }, 3000);

        let walletName = "";

        Array.isArray(this.state.ETRC20) && this.state.ETRC20.some((v) => {
            if (v.walletAddress === values.ctcAddress) {
                walletName = v.walletName;
            }
        });

        this.props.setLoading(true);
        //let { platformType, languageType, device } = this.feWalletParams
        let { language, swiftCode, isMobile } = PParamsData()
        CommonPostPay(
            {
                depositingBankName: values.bankaccount || "",
                accountNumber: values.ctcAddress,
                accountHolderName: walletName,
                language,
                swiftCode,
                paymentMethod: this.typeCode,
                amount: values.money,
                transactionType: "Withdrawal",
                convertedCurrency: this.state.ctcType,
                domainName: this.feWalletParams.domainName,
                isMobile,
                isSmallSet: false,
                successUrl: this.feWalletParams.successUrl,
                seonSession: await this.feWalletParams.getSeonSession(),
                // maxPayoutDurationInMins: 300,  P2 INCIDENT-56545
                // payoutDurationRebatePercent: 0.1
            },
            (res) => {
                // let res = {
                //     "result": {
                //         "transactionId": "W202309282810016",
                //         "successBonusId": "",
                //         "warnings": [],
                //         "uniqueAmount": 0.0,
                //         "bonusApplicationMessage": "",
                //         "bonusResult": "",
                //         "submittedAt": "2023-09-28T15:38:01.5312441+08:00",
                //         "isQR": false,
                //         "isDummyBank": false,
                //         "showVendorBank": false,
                //         "payoutMode": "",
                //         "vendorCharges": false,
                //         "actualAmount": 0.0,
                //         "charges": 0.0,
                //         "totalWaiveRemain": 0
                //     },
                //     "isSuccess": true,
                //     "errors": []
                // };

                this.props.setLoading(false);

                if (res.isSuccess) {
                    this.feWalletParams?.reloadBalance()
                    const RESULT = res.result;
                    this.feWalletParams?.toggleHideWithdrawHeader && this.feWalletParams?.toggleHideWithdrawHeader(false)

                    // typeof this.applyBonusCallback === "function" && this.applyBonusCallback({
                    //     transactioinType: "Deposit",
                    //     ...values,
                    //     ...RESULT
                    // });

                    this.transactionId = RESULT.transactionId;

                    this.setStep(2);
                    this.setDepositTime(RESULT.submittedAt);
                    this.setState({ depositMoney: values.money });

                } else {
                    this.setState({
                        submitDisabled: true
                    })
                    withdrawModalHandle({
                        res,
                        PendingWithdraw: this.props.PendingWithdraw,
                        WithdrawKycModal: this.props.WithdrawKycModal,
                        InsertNewAccountHolderName: () => { InsertNewAccountHolderName(walletName) },
                        accountHolderName: walletName,
                        firstName: this.props.memberInfo.firstName,
                        methods: 'CCW'
                    })
                }

                // depositErrPrompt(RESULT);
            }
        );

        // Pushgtagdata("Deposit", "Submit", `Submit_${this.typeCode}_Deposit​`);
    }

    goHome = () => {
        this.setState({ step: 1 }, () => {
            this.formInstance.setFieldValue("money", "");
        });
    }

    render() {

        const {
            WithdrawalSuccessTimer,
            WithdrawalMoney,
            BankAccount,
            CTCAccount,
            ExchangeExtra,
            ExchangeExtra2,
            AddCTCAddress,
            AddressSelect,
            SubmitBtn,
            FormType,
            Input,
            Item,
            WithdrawalTutoria,
            changeMethod
        } = this.props;

        const {
            setDepositDetail,
            currAvailableMethods,
            availableCoinTypes,
            style = {},
            currDepositDetail // 当前充值方式详细数据
        } = this.props;
        const commonParams = {
            Item: Item,
            Input: Input,
            form: this.formInstance,
            typeCode: this.typeCode,
            setting: currDepositDetail.setting,
            setLoading: this.props.setLoading,
            setCurrFormData: this.setCurrFormData
        };
        const { setting } = commonParams;
        return <>
            {this.state.step === 1 ? <Form
                component={FormType}
                ref={(form) => {form && (this.setFormInstance(form))}}
                onFieldsChange={this.setSubmitButtonStatus}
                onFinish={(values) => {
                    this.submitOnce(values);
                }}
                style={style}
            >
                {setting && !setting.isAutoAssign ? <BankAccount
                    label={translate("银行选择")()}
                    bankIconName="enBankName"
                    suffixNoParam="accountNo"
                    notRequired={true}
                    setFormStaticData={this.formStaticData.setData}
                    bankAccounts={currDepositDetail && currDepositDetail.bankAccounts}
                    {...commonParams}
                /> : null}
                <CTCAccount
                    bankAccounts={availableCoinTypes}
                    setFormStaticData={this.formStaticData.setData}
                    changeType={(v) => {
                        this.setState({ctcType: v})
                        changeMethod('CCW', v.replace("USDT-", ""))
                        if (this.feWalletParams.device == 'APP') {
                            this.feWalletParams.appPiwikEvent({
                                category: 'Withdrawal',
                                action: `Switch to Crypto ${v}`,
                                name: `Withdrawal_Crypto_C_TRC`,
                                path: `withdrawal_crypto`,
                                title: `Withdrawal`
                            })
                        }
                    }}
                    {...commonParams}
                />
                <WithdrawalMoney
                    uniqueAmountStatus={this.props.uniqueAmountStatus}
                    onChange={this.moneyChangeCallback}
                    allowDecimals={false}
                    {...commonParams}
                />
                {this.state.exchangeRateVal ? <Item
                    fieldName="exchange_other"
                    label={translate("虚拟币等值数量")()}
                    extra={
                        this.state.exchangeRateInfo.tiersExchangeAmount && !Object.values(this.state.exchangeRateInfo.tiersExchangeAmount)?.some(x => Number(x) == 0) ? 
                        <ExchangeExtra2
                            title={translate("汇率：")()}
                            tip1={translate("级别 1：1 <#0#> = <#1#> RMB")(this.state.ctcType, 
                                formatAmount(( 1 / Number(this.state.exchangeRateInfo.tiersExchangeRate[1]) ), 3))}
                            tip2={translate("级别 2：1 <#0#> = <#1#> RMB")(this.state.ctcType, 
                                formatAmount(( 1 / Number(this.state.exchangeRateInfo.tiersExchangeRate[2]) ), 3))}
                            tip3={translate("注：汇率仅供参考，交易将按交易时的汇率计算。")()}
                            btn={translate("单击此处查看其计算方法")()}
                            onClick={this.rateTip}
                        /> : <ExchangeExtra
                                tip1={translate("汇率：1 <#0#> = <#1#> RMB")(this.state.ctcType, this.state.USDTExchangeRate)}
                                tip2={translate("此汇率仅供参考，交易将按提现时的实际汇率计算。")()}
                            />
                    }
                >
                    {() => (
                        <Input className="CTCInput" value={this.state.exchangeRateVal + " " + this.state.ctcType} disabled />
                    )}
                </Item> : null}
                {this.state.disabled ? <Item
                    fieldName="ctc_type"
                    label={translate("钱包地址")()}
                    rules={[{
                        required: true,
                        message: translate("钱包地址不可为空")()
                    }]}
                >
                    {() => (
                        <AddCTCAddress ctcType={this.state.ctcType} onEvent={this.addAddUSDT} />
                    )}
                </Item> : (this.state.ETRC20 && this.state.ETRC20.length ? <Item
                    fieldName="ctcAddress"
                    label={translate("钱包地址")()}
                    rules={[{
                        required: true,
                        message: translate("钱包地址不可为空")()
                    }]}
                >
                    {(control) => (
                        <AddressSelect
                            isSearch={false}
                            placeholder={translate("钱包地址")()}
                            list={this.state.ETRC20}
                            currValue={control.value}
                            valueKey="walletAddress"
                            valueName="walletName"
                            addEvent={this.addAddUSDT}
                            ctcType={this.state.ctcType}
                            onSelectChange={(v) => {v === -1 ? this.addAddUSDT() : control.onChange(v)}}
                        />
                    )}
                </Item> : null)}
                <SubmitBtn
                    disabled={this.state.submitDisabled}
                    onClick={() => {
                        this.formInstance && this.formInstance.submit();
                    }}
                    goCCWGuide={this.feWalletParams.goCCWGuide}
                />
            </Form> : null}
            {this.state.step === 2 ? <WithdrawalSuccessTimer
                goHome={this.goHome}
                type={"CCW"}
                transactionId={this.transactionId}
                depositMoney={this.state.depositMoney}
                depositDateTime={this.state.depositDateTime}
                clearDateTime={this.clearDateTime}
                goBack={this.goBack}
            /> : null}

            {
                (this.state.step === 1 || (this.feWalletParams?.device === "WEB" && this.state.step === 2)) &&
                <WithdrawalTutoria
                    visible={this.state.tutoriaVisible} 
                    onChange={() => { this.setState({tutoriaVisible: !this.state.tutoriaVisible}) }}
                />
            }
        </>
    }
}

const mapStateToProps = (state) => ({
	userInfo: state.userInfo
});

export default connect(mapStateToProps)(CCW);
